import React from 'react'

import { Grid } from '@material-ui/core'

import Button from '../../../../UI/Button/Button'

import StructureList from './StructureList/StructureList'
import ItemList from './ItemList/ItemList'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const ItemListSelector = ({
  currentStructure,
  selectedStructures,
  selectedItems,
  selectedTags,
  structureSelected,
  itemSelected,
  tagSelected,
  addItemButtonClicked,
  items,
  structures,
  translate
}) => {
  const structureCode = currentStructure?.structure_type?.value_list_code
  const theme = useTheme()
  const MobileVertical = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Grid container>
      {MobileVertical ? (
        <>
          <Grid
            container
            item
            spacing={2}
            justify={'flex-start'}
            style={{ width: '100%', margin: 0 }}>
            <Grid item xs>
              <StructureList
                itemClicked={structureSelected}
                structures={structures}
                currentStructures={selectedStructures}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} justify={'center'} style={{ width: '100%', margin: 0 }}>
            <Grid item xs>
              <ItemList
                items={items}
                currentItems={selectedItems}
                itemClicked={itemSelected}
                selectedTags={selectedTags}
                tagSelected={tagSelected}
                structureCode={structureCode}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid
            container
            item
            spacing={2}
            justify={'flex-start'}
            style={{ width: '100%', margin: 0 }}>
            <Grid item xs>
              <StructureList
                itemClicked={structureSelected}
                structures={structures}
                currentStructures={selectedStructures}
              />
            </Grid>
            <Grid item xs>
              <ItemList
                items={items}
                currentItems={selectedItems}
                itemClicked={itemSelected}
                selectedTags={selectedTags}
                tagSelected={tagSelected}
                structureCode={structureCode}
              />
            </Grid>
          </Grid>
        </>
      )}
      <Grid container item spacing={2} justify={'flex-end'} style={{ width: '100%', margin: 0 }}>
        <Grid item xs sm={3} md={4} lg={2}>
          <Button
            color={'primary'}
            clicked={addItemButtonClicked}
            disabled={selectedItems.length < 1 && selectedTags.length < 1}>
            {translate('add')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withTranslate(ItemListSelector)
